import gql from 'graphql-tag';

const query = gql`
  query BloodSugarDaysMeasurements($days: Int) {
    diabetes {
      bloodSugarMeasurements {
        userMeasurementDays(first: $days) {
          edges {
            cursor
            node {
              date
              measurements {
                id
                value {
                  value
                  unit
                }
                valueLabel
                date
                type
                mealType
                source
                customLabel
                insulinDose {
                  dose
                  carbohydrateUnits
                  insulinToCarbRatio
                  insulinCorrectionFactor
                }
              }
              minMeasurementValue {
                value
                unit
              }
              maxMeasurementValue {
                value
                unit
              }
            }
          }
        }
      }
    }
  }
`;

export default query;
